module.exports = __webpack_public_path__ + "static/media/pen-square.f313e71f.svg";